<template>
  <div class="indexBox">
    <a-back-top />
    <div class="index_top">
      <a-affix :offset-top="top">
        <img src="../../static/img/index/fixTop.png" alt="" class="top" />
        <img src="../../static/img/index/logo.png" alt="" class="logo" />
      </a-affix>
      <indexNav class="index_nav"></indexNav>
      <a-carousel
        :after-change="onChange"
        autoplay
        class="indexLoop"
        effect="fade"
      >

        <div>
          <img src="../../static/img/index/01.jpg" alt="banner_01" style="width: 100%" />
        </div>
        <!-- <div>
          <img src="../../static/img/index/shehui01.jpg" alt="shehui_01" style="width: 100%" />
        </div> -->
        <!-- <div>
          <img src="../../static/img/index/shehui02.jpg" alt="shehui_02" style="width: 100%" />
        </div> -->
        <!-- <div>
          <img src="../../static/img/index/shehui03.jpg" alt="shehui_03" style="width: 100%" />
        </div> -->
        <div>
          <img src="../../static/img/index/02.jpg" alt="" style="width: 100%" />
        </div>
        <div>
          <img src="../../static/img/index/03.jpg" alt="" style="width: 100%" />
        </div>
        <div>
          <img src="../../static/img/index/04.jpg" alt="" style="width: 100%" />
        </div>
        <div>
          <img src="../../static/img/index/05.jpg" alt="" style="width: 100%" />
        </div>
        <div>
          <img src="../../static/img/index/06.jpg" alt="" style="width: 100%" />
        </div>
      </a-carousel>
    </div>

    <div style="clear: both"></div>
    <div class="container">
      <indexContent></indexContent>
    </div>
    <!-- 底部友情链接 -->
    <div class="friLink">
      <div class="friLinkInner">
        <a href="http://hvae.hee.gov.cn/" target="_blank" tag="div">
          <img src="../../static/img/index/fr01.png" alt=""
        /></a>
        <a href="http://www.cvae.com.cn/zgzcw/" target="_blank" tag="div"
          ><img src="../../static/img/index/fr02.png" alt=""
        /></a>
        <a href="http://www.moe.gov.cn/" target="_blank" tag="div"
          ><img src="../../static/img/index/fr03.png" alt=""
        /></a>
        <a href="http://jyt.hebei.gov.cn/" target="_blank" tag="div"
          ><img src="../../static/img/index/fr04.png" alt=""
        /></a>
      </div>
    </div>
    <div class="footer_box">
      <div class="footer_box_content">
        <div>
          <img src="../../static/img/index/shiye.png" alt="" />
        </div>
        <div>
          <img src="../../static/img/index/ass.png" alt="" />
          <div>
            <div>地址</div>
            <div>刘营村东一公里</div>
          </div>
        </div>
        <div>
          <img src="../../static/img/index/phone.png" alt="" />
          <div>
            <div>电话</div>
            <div>0310-6726179 15188827008</div>
          </div>
        </div>
        <div>
          <img src="../../static/img/index/chuanzhen.png" alt="" />
          <div>
            <div>传真</div>
            <div>0310-6726179</div>
          </div>
        </div>
        <div>
          <img src="../../static/img/index/email.png" alt="" />
          <div>
            <div>邮件</div>
            <div>webmaster@ynzjzx.com</div>
          </div>
        </div>
        <div style="height: 125px;text-align: center;">
          <div style="height: 125px">
            <div style="height: 90px">
              <img style="height: 100%" src="../../static/img/index/erwei_baoming.png" alt="在线报名"/>
            </div>
            <div>扫码报名</div>
          </div>
        </div>
        <div style="height: 125px;text-align: center;">
          <div style="height: 125px">
            <div style="height: 90px">
              <img style="height: 100%" src="../../static/img/index/erwei.jpg" alt="公众号"/>
            </div>
            <div> 微信公众号</div>
          </div>
        </div>
      </div>
    </div>
    <!-- <a href="http://192.168.10.62:8082\files\骨干建设与申报\骨干专业资料（计算机平面设计）\M1专业设置\M1-1专业设置调研论证\01计算机平面设计专业调研报告\01专业调研报告.swf">a</a> -->
    <!-- <specDyDetailChil></specDyDetailChil> -->
    <div class="footerest">

      Copyright &copy; 2009-2021 永年区职教中心 版权所有 <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">冀ICP备20004636号</a>
    </div>
  </div>
</template>

<script>
import indexNav from "../components/indexComp/indexNav";
import indexContent from "../components/indexComp/indexContent";
// import specDyDetailChil  from './details/specDyDetailChil.vue'
// import lib from "../../static/js/loadFile";

export default {
  name: "index",
  components: { indexNav, indexContent },
  data() {
    return {
      top: 0,
    };
  },
  methods: {
    onChange(a, b, c) {
      // console.log(a, b, c)
    },
    // aa(e){
    //   console.log(e);
    // }
  },
  created() {},
};
</script>

<style scoped>
.indexBox {
  /* min-width: 1200px; */
  position: relative;
}

* {
  margin: 0;
  padding: 0;
}

.index_top {
  position: relative;
}

.index_nav {
  position: absolute;
  top: 5px;
  right: 3%;
  z-index: 11;
  width: 65%;
}

div /deep/ .slick-dots-bottom {
  bottom: 15% !important;
}

.logo {
  position: absolute;
  top: 10px;
  left: 3%;
  z-index: 11;
  width: 20%;
}

.top {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 11;
}

.ant-carousel >>> .slick-slide {
  text-align: center;
  overflow: hidden;
}

.slick-track {
  height: 100% !important;
}

.ant-carousel >>> .slick-slide h3 {
  color: #fff;
}

.indexLoop {
  width: 100%;
}

.indexLoop div img,
.indexLoop div {
  width: 100% !important;
  height: 100% !important;
}


@media screen and (min-width: 1200px) and (max-width: 1920px) {
  .container {
    width: 73%;
    margin: 0 auto;
    margin-bottom: 15px;
    position: relative;
  }
}
@media screen and (min-width: 375px) and (max-width: 800px) {
 .container {
  width: 90%;
  margin: 0 auto;
  margin-bottom: 15px;
  position: relative;
}
}

.friLink {
  width: 100%;
  background-image: url("../../static/img/index/indexFooter.png");
  background-size: 100% 100%;
  padding: 3% 0 3.5% 0;
  box-shadow: 0px 0px 20px 0px rgba(0, 91, 176, 0.1);
}

.friLinkInner {
  width: 62%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}

.friLinkInner > a {
  width: 22%;
  cursor: pointer;
}

.friLinkInner > a > img {
  width: 100%;
}

.footer_box {
  width: 100%;
  padding: 10px 0px;
      padding-top: 20px;
  background-color: #006cab;
  color: white;
}
 .footer_box_content {
    width: 62%;
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    align-items: center;
  }

@media screen and (min-width: 1200px) and (max-width: 1920px) {
  .footer_box_content {
    width: 62%;
  }
}
@media screen and (min-width: 300px) and (max-width: 750px) {
 .footer_box_content{
    width: 96% ;
 }
}

.footer_box_content > div {
  display: flex;
  justify-content: space-between;
}

.footer_box_content > div > img {
  height: max-content;
  margin-right: 10px;
}

.footer_box_content > img {
  height: max-content;
}

.footerest {
  width: 100%;
  text-align: center;
  background: #006196;
  height: 40px;
  line-height: 40px;
  color: #c5c5c7;
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue